import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { getTranslations } from 'actions/localization';
import SpinnerCredit24 from 'components/Credit24/Core/Spinner';
import LoanStepError from 'components/Credit24/LoanApplication/LoanStepError';
import Button from 'components/common/Button';
import PageHeaderCreditea from 'components/Creditea/Core/PageHeader';
import PageHeaderCredit24 from 'components/Credit24/Core/PageHeader';
import SpinnerCreditea from 'components/Creditea/Core/Spinner';
import LoanStepTechnicalError from 'components/Creditea/LoanApplication/LoanStepTechnicalError';
import queryStringParser from 'utils/queryStringParser';

let loadingContent;
let errorContent;

if (COUNTRY === 'MX' || COUNTRY === 'ES' || COUNTRY === 'PL' || COUNTRY === 'CZ') {
  loadingContent = (
    <div className="page-container">
      <div className="page-wrapper">
        <div className="page-content">
          <SpinnerCreditea />
        </div>
      </div>
    </div>
  );

  errorContent = (
    <div className="page-container">
      <div className="page-wrapper">
        <PageHeaderCreditea authentication={{ isAuthenticated: false }} />
        <div className="page-content">
          <LoanStepTechnicalError />
        </div>
      </div>
    </div>
  );
} else {
  loadingContent = (
    <div className="page-container">
      <div className="page-wrapper">
        <div className="page-content">
          <SpinnerCredit24 />
        </div>
      </div>
    </div>
  );

  const tryAgain = () => window.location.reload();

  errorContent = (
    <div className="page-container">
      <div className="page-wrapper">
        <PageHeaderCredit24
          authentication={{ isAuthenticated: false }}
          country={COUNTRY || queryStringParser.parseAndMakeKeysLowerCase(location.search).country || ''}
        />
        <div className="page-content">
          <div className="container">
            <div className="loan-form">
              <LoanStepError
                title={<FormattedHTMLMessage id="technical.error.title" />}
                text={<FormattedHTMLMessage id="technical.error.body" />}
                button={(
                  <Button
                    type="button"
                    onClick={tryAgain}
                  >
                    <FormattedMessage id="technical.error.retry" />
                  </Button>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const propTypes = {
  getTranslations: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

export default (Content, country = COUNTRY.toLowerCase()) => {
  class TranslationsContainer extends Component {
    componentDidMount() {
      this.props.getTranslations(country, this.props.intl.locale);
    }

    componentDidUpdate(prevProps) {
      const { intl: { locale, loadedLocales } } = this.props;
      const { intl: { locale: prevLocale } } = prevProps;

      if (locale !== prevLocale && !loadedLocales.includes(locale)) {
        this.props.getTranslations(country, locale);
      }
    }

    render() {
      const { intl, ...rest } = this.props;
      const { areTranslationsLoading, loadedLocales, isError } = intl;

      if (isError) {
        return errorContent;
      }

      if (areTranslationsLoading || loadedLocales.length === 0) {
        return loadingContent;
      }

      return <Content {...rest} />;
    }
  }

  TranslationsContainer.propTypes = propTypes;

  return connect((state) => ({ intl: state.intl }), { getTranslations })(TranslationsContainer);
};
